import React from "react";
import { Spin } from 'antd';
import './Spinner.scss';


const Spinner = () => (
  <div className="spinner-wrapper" role="status" aria-live="polite" aria-label="Loading">
    <Spin size="large" aria-hidden="true" />
  </div>
);

export default Spinner;
